import { createSlice } from "@reduxjs/toolkit";
import {
  parseJobApiResponse,
} from "../../../utils";

// TODO: replace utils
import { useLazyGetJobByIdFromApiQuery } from '../../../services/jobsApi'

export const jobsSlice = createSlice({
  name: "jobs",
  initialState: {
    list: []
  },
  reducers: {
    setJobsList: (state, action) => {
      if(action.payload) state.list = action.payload
    },
    updateOneJob: (state, action) => {
      if(action.payload) state.list = state.list.map((job) =>
        job.id == action.payload.id ? action.payload : job
      );
    },
    addJob: (state,action)=>{
      let jobExists= state.list.find(x => x.id == action.payload.id)
      if(jobExists) console.log("Job exists in Redux state, DROP: " + action.payload.id);
      if(action.payload && !jobExists) state.list.push(action.payload)
    }
  },
});

// we can export the action of above to be used
export const { setJobsList, updateOneJob, addJob } = jobsSlice.actions;

export const selectAllJobs = (state) => (state.jobs.list)

export default jobsSlice.reducer;

// this function has to return another function
// that return is expressed in a implicit way
export const setDataGridJobsData = (res) => async (dispatch) => {
  // request
  console.log("Updating list...");

  if (res.status !== "Ok") throw new Error(JSON.stringify(res));
  console.log("jobs res: ", res)
  let jobsObj = parseJobApiResponse(res.res);
  let data = getDataGridProps(jobsObj);
  dispatch(setJobsList(data))

};
// redux manage the network petitions by a middleware ( dank is the default one)
// a dispatcher is who is encharged to execute the action

export const updateOneJobById = (jobId) => async (dispatch) => {
  const [initGetJobByIdFromApi, {isLoading: getJobByIdFromApiIsLoading}] = useLazyGetJobByIdFromApiQuery();

  console.log("UPDATING JOB: ", jobId);
  try {
    var res = await initGetJobByIdFromApi(jobId).unwrap();
    if (res.status !== "Ok") throw new Error(JSON.stringify(res));


  } catch (error) {
    console.log("UPDATING JOB: error fetching Data to update job in manageJobs for job ID: ", jobId , error);
    return;
  }
try {
  var jobsObj = parseJobApiResponse(res.res);
  var newJob = getDataGridProps(jobsObj)[0]
  
} catch (error) {
console.log("UPDATING JOB: error parsing response", error)
return;
}

  console.log("UPDATING JOB: Job to update: ", newJob)
  dispatch(updateOneJob(newJob));
};

export const addJobById = (jobId)=> async(dispatch) => {
  const [initGetJobByIdFromApi, {isLoading: getJobByIdFromApiIsLoading}] = useLazyGetJobByIdFromApiQuery();

  console.log("ADDING JOB: ", jobId);
  try {
    var res = await initGetJobByIdFromApi(jobId).unwrap();
    if (res.status !== "Ok") throw new Error(JSON.stringify(res));


  } catch (error) {
    console.log("ADDING JOB: error fetching Data to update job in manageJobs for job ID: ", jobId , error);
    return;
  }
try {
  var jobsObj = parseJobApiResponse(res.res);
  var newJob = getDataGridProps(jobsObj)[0]
  
} catch (error) {
console.log("ADDING JOB: error parsing response", error)
return;
}

  console.log("ADDING JOB: Job to add: ", newJob)
  dispatch(addJob(newJob));
}

function getDataGridProps(jobsObj) {
  let r = [];
  jobsObj.forEach((jobObj) => {
    r.push({
      ...jobObj.job, //A: jobInfo
      ...jobObj.event, //A: event info
      escalationActive: jobObj.escalationActive, //A: the currente escalation if exists
    });
  });
  return r;
}


// // use RTK-Query
// const { data, error, isError, isLoading, isSuccess } = useJobsQuery();